import { render } from "./MinusIcon.vue?vue&type=template&id=09c17cc5"
import script from "./MinusIcon.vue?vue&type=script&lang=js"
export * from "./MinusIcon.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/application/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__